/* Videos in der Produktgalerie (Moritz 20.10.2026).
   Die Galerie in materea-pdp.js blaettert nur Bilder: sie setzt aria-current an der aktiven Kachel und
   tauscht das Hauptbild gegen data-src (bei einer Video-Kachel ist das ihr Vorschaubild). Dieses Skript
   legt ueber das Hauptbild ein stummes Video in Schleife, sobald die aktive Kachel data-film traegt, und
   nimmt es wieder weg, sobald ein Bild aktiv ist. Eigene Datei, damit die Galerie-Logik unberuehrt bleibt.
   data-film setzt das Liquid in materea-pdp-kaufzone (Quelle build-theme-pdp.py, gal_neu), geladen wird
   die Datei nur auf Produkten mit Video in der Leiste. Wer Bewegung reduziert, bekommt Steuerelemente
   statt Autoplay. */
(function(){
  var main = document.getElementById('pd-gal-img');
  var leiste = document.querySelector('.pd-thumbs');
  if (!main || !leiste || !leiste.querySelector('.pd-thumb[data-film]')) return;
  var ruhig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var play = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M9 6.5v11l9-5.5z' fill='%23fff'/%3E%3C/svg%3E\")";
  var css = document.createElement('style');
  css.textContent =
    '.pd-gal-film{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:var(--stage);display:block}' +
    '.pd-gal-film[hidden]{display:none}' +
    '.pd-thumb[data-film]:not(.pd-thumb-mehr)::before{content:"";position:absolute;left:50%;top:calc(50% - 2.5px);' +
    'width:30px;height:30px;margin:-15px 0 0 -15px;border-radius:50%;background:rgba(11,11,11,.62) ' + play +
    ' center/16px no-repeat;pointer-events:none;z-index:1}';
  document.head.appendChild(css);

  var film = null;
  function sync(){
    var t = leiste.querySelector('.pd-thumb[aria-current="true"]');
    var url = t && t.getAttribute('data-film');
    if (!url){
      if (film && !film.hidden){ film.pause(); film.hidden = true; }
      return;
    }
    if (!film){
      film = document.createElement('video');
      film.className = 'pd-gal-film';
      film.muted = true; film.defaultMuted = true; film.loop = true; film.playsInline = true;
      film.setAttribute('muted', ''); film.setAttribute('playsinline', ''); film.setAttribute('loop', '');
      film.preload = 'metadata';
      main.insertAdjacentElement('afterend', film);
    }
    if (t.dataset.src) film.poster = t.dataset.src;
    if (film.getAttribute('src') !== url) film.setAttribute('src', url);
    film.setAttribute('aria-label', t.dataset.alt || '');
    film.controls = ruhig;
    film.hidden = false;
    if (!ruhig){
      var p = film.play();
      if (p && p.catch) p.catch(function(){ film.controls = true; });
    }
  }

  new MutationObserver(sync).observe(leiste, {subtree: true, attributes: true, attributeFilter: ['aria-current']});
  sync();
})();
